import { useTheme } from '@emotion/react';
import { Button, Grid, Popover, Typography } from '@mui/material';
import React from 'react';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import { imageAddressPrefix } from 'spec';

const AryTriplexComponentsLock = ({
  open,
  components,
  anchorEl,
  lockedComponent,
  setLockComponentOnChange,
  handleClose
}) => {
  const theme = useTheme();
  const { t } = useFrameworkTranslation();

  const handleComponentSelection = (component) => {
    setLockComponentOnChange(component);
  };

  const renderPopoverContent = () =>
    components
      .filter((component) => component.value !== lockedComponent.value)
      .map((component) => (
        <Button
          key={component.value}
          variant="outlined"
          onClick={() => handleComponentSelection(component)}
          sx={{
            borderRadius: '8px',
            border: '1px solid #647E9A',
            color: '#647E9A',
            padding: '0.25rem 0.75rem !important',
            width: '100%',
            height: '2rem'
          }}
        >
          {t(component.label)}
        </Button>
      ));

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      PaperProps={{
        sx: {
          width: '20.375rem',
          height: 'fit-content',
          padding: '28px 24px',
          boxShadow: '.25rem .25rem .875rem 0 rgba(0, 0, 0, 0.1)',
          alignContent: 'center'
        }
      }}
    >
      <Grid
        container
        columnSpacing={theme.padding.gridSmallColumnSpacing}
        rowSpacing={theme.padding.gridSmallRowSpacing}
        justifyContent="center"
      >
        <Grid item xs={12} textAlign="center">
          <Grid container>
            <Grid item xs={2}>
              <img
                alt="cloud"
                style={{
                  height: '26px',
                  width: '23px'
                }}
                src={`${imageAddressPrefix}static/img/illustrations/CalculatorIcon.svg`}
              />
            </Grid>
            <Grid item xs={10} alignContent="center">
              <Typography variant="h5Bold">
                {t('SelectItemToAutoCalculate')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display="flex" gap={1}>
          {renderPopoverContent()}
        </Grid>
      </Grid>
    </Popover>
  );
};

export default AryTriplexComponentsLock;
